/**
 * Vuely Global Components
 */
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import AppSectionLoader from 'Components/AppSectionLoader/AppSectionLoader'
import { RotateSquare2 } from 'vue-loading-spinner'

// confirmation Dialog
import ConfirmationDialog from 'Components/Dialogs/ConfirmationDialog'

// Information Dialog
import InfoDialog from 'Components/Dialogs/InfoDialog'

// DataTable
import DataTable from 'Components/DataTable/DataTable'

// Snackbar
import Snackbar from 'Components/Snackbar/Snackbar'

// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar'

// App Card component
import AppCard from 'Components/AppCard/AppCard'

// stats card
import StatsCard from 'Components/StatsCard/StatsCard'
import StatsCardV2 from 'Components/StatsCard/StatsCardV2'
import StatsCardV3 from 'Components/StatsCard/StatsCardV3'

// section tooltip
import SectionTooltip from 'Components/SectionTooltip/SectionTooltip'

//Detail dialog technologi
import DetailTechnologiDialog from '@/components/Technologies/DetailTechnologiDialog'

// Dialog Historico
import DownloadHistoricoDialog from '@/components/Historicos/DownloadHistoricoDialog'

// Inputs Reportes
import CDate from '@/components/inputs/CDate'
import CNumber from '@/components/inputs/CNumber'
import CTexto from '@/components/inputs/CTexto'

const GlobalComponents = {
   install(Vue) {
      Vue.component('DetailTechnologiDialog', DetailTechnologiDialog)
      Vue.component('appCard', AppCard)
      Vue.component('sectionTooltip', SectionTooltip)
      Vue.component('statsCard', StatsCard)
      Vue.component('statsCardV2', StatsCardV2)
      Vue.component('statsCardV3', StatsCardV3)
      Vue.component('confirmationDialog', ConfirmationDialog)
      Vue.component('infoDialog', InfoDialog)
      Vue.component('DataTable', DataTable)
      Vue.component('Snackbar', Snackbar)
      Vue.component('vuePerfectScrollbar', VuePerfectScrollbar)
      Vue.component('appSectionLoader', AppSectionLoader)
      Vue.component('pageTitleBar', PageTitleBar)
      Vue.component('rotateSquare2', RotateSquare2)
      Vue.component('DownloadHistoricoDialog', DownloadHistoricoDialog)
      Vue.component('CDate', CDate)
      Vue.component('CNumber', CNumber)
      Vue.component('CTexto', CTexto)
   }
}

export default GlobalComponents
